import { useCallback, useState } from 'react';

/**
 * Хук можно использовать для проброса ошибки до ближайшего ErrorBoundary тогда,
 * когда ошибка происходит в асинхронном коде и ErrorBoundary сам эту ошибку отловить не может
 * https://github.com/facebook/react/issues/14981#issuecomment-468460187
 */
export function usePropagateErrorToBoundary(): (error: Error) => void {
  const [, setErrorState] = useState<Error>();

  return useCallback((error: Error) => {
    setErrorState(() => {
      throw error;
    });
  }, []);
}
